import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subStatus, setSubStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const hp = (form.elements.namedItem('contact_alt') as HTMLInputElement)?.value;
    if (hp && hp.trim()) {
      setSubStatus('success');
      setEmail('');
      return;
    }
    if (!email || !email.includes('@')) {
      setSubStatus('error');
      return;
    }
    setSubStatus('success');
    setEmail('');
  };

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand & Subscribe */}
          <div className="lg:col-span-2 space-y-6">
            <div>
              <Link to="/" className="inline-flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-lg" />
                </div>
                <span className="font-heading text-xl font-bold text-foreground-950">
                  猎奇吃瓜
                </span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                每日新鲜吃瓜八卦、冷门趣味爆料及无压力围观趣事，
                为围观心态提供解压谈资与社交分享素材，拒绝重复和垃圾信息。
              </p>
            </div>

            <form onSubmit={handleSubscribe} className="space-y-3">
              <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                订阅每日瓜报
              </p>
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setSubStatus('idle'); }}
                  placeholder="输入您的邮箱"
                  className="flex-1 px-3 py-2.5 bg-background-50 border border-secondary-300 rounded-md text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
                />
                <input
                  type="text"
                  name="contact_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 border border-primary-500 text-primary-500 rounded-md text-sm font-medium hover:bg-primary-500 hover:text-white transition-colors whitespace-nowrap"
                >
                  订阅
                </button>
              </div>
              {subStatus === 'success' && (
                <p className="text-xs text-secondary-700">订阅成功！感谢您的关注</p>
              )}
              {subStatus === 'error' && (
                <p className="text-xs text-primary-600">请输入有效的邮箱地址</p>
              )}
            </form>
          </div>

          {/* Links columns */}
          <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">解压专区</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/category/wangluo-regeng" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    网络热梗
                  </Link>
                </li>
                <li>
                  <Link to="/category/jieya-tanzi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    解压谈资
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    今日热门
                  </Link>
                </li>
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    网友神评
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">关于与联系</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <span className="text-sm text-foreground-600">商务合作：hello@odki7b.com</span>
                </li>
                <li>
                  <span className="text-sm text-foreground-600">爆料投稿：hello@odki7b.com</span>
                </li>
                <li>
                  <span className="text-sm text-foreground-600">意见反馈：hello@odki7b.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 猎奇吃瓜. 每日新鲜八卦，拒绝垃圾信息.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}